import React from 'react'

export const Users = [
  {
    name: 'list',
    component: React.lazy(() => import('../../../modules/common/UsersList')),
    path: '/admin/users',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'create',
    component: React.lazy(() => import('../../../modules/common/users/UsersCreate')),
    path: '/admin/users/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'edit',
    component: React.lazy(() => import('../../../modules/common/users/UsersEdit')),
    path: '/admin/users/edit/:userId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
